
































































































































































































































































































































































import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import { IFormStore } from '@/store/types'
import { TCWDataLoadError, TCWApiError } from '@/plugins/TCWBaseError'
import { kintaiInputStore } from '@/store/form/KintaiInputFormStore'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { CodeLabel, ApiGeneralSinglePayload, ApiGeneralObjectArrayPayload } from '@/tcw/api/types'
import {
  KEY_CLASS_GYOUSHU_CODE,
  KEY_CLASS_CHIKOKU_TYPE,
  KEY_CLASS_SOUTAI_TYPE,
  KEY_CLASS_KYUJITSU_TYPE,
  KEY_CLASS_KEKKON_KYUKA_OPTION,
  KEY_CLASS_KIBIKI_KYUKA_OPTION,
  KEY_CLASS_KINMU_KEITAI,
  KEY_CLASS_KINMU_JIKAN_KEISAN_TYPE
} from '@/tcw/constant/KeyClass'
import * as ApiPath from '@/tcw/constant/ApiPath'
import { TcwAPIDate, TcwAPIID, TcwFormDate } from '@/tcw/domain/types'
import Jikan from '@/tcw/domain/Jikan'
import { API_DAYTIME_FORMAT } from '@/tcw/domain/format'
import { ERR_CODE_WEB_API_NOT_FOUND } from '@/tcw/constant/ErrorCode'
import ChienshomeiMixin from '@/components/kintai/mixins/ChienshomeiMixin'
import KintaiGaishutsuJikanFormItem from '@/components/kintai/molecules/KintaiGaishutsuJikanFormItem.vue'
import { KeyInfo } from '@/components/common/form/types'
import _ from 'lodash'

@Component({
  components: { KintaiGaishutsuJikanFormItem }
})
export default class KintaiInputForm extends Mixins(FormStoreComponent, ChienshomeiMixin) {
  @Prop({ type: Date, default: () => new Date() })
  private inputDate!: Date
  private kintaiPatternList: ApiGeneralObjectArrayPayload = []

  @Emit()
  private successSave(): void {
    /** */
  }

  private gyoushuList: CodeLabel[] = []

  private jikanInputCnt = 0
  private isCalculating = false
  private kaishiJikan: Jikan | null = null
  private shuryoJikan: Jikan | null = null
  private koutsuhiPatternList: ApiGeneralObjectArrayPayload = []
  private koutsuhiHasseiInfo: ApiGeneralSinglePayload = {}
  private kintaiJikan: ApiGeneralSinglePayload = {}
  private get kyujitsuData(): ApiGeneralSinglePayload {
    return {
      kaishi: '',
      shuryo: '',
      chikokuCode: '',
      sotaiCode: '',
      kyukei1: null,
      kyukei2: null,
      hushurou: null,
      gyoumu: '',
      koutei: '',
      kinmuKeitai: '',
      koutsuhiSonota: null,
      shugyouKeitaiCode: null
    }
  }
  private kyujitsuTypeList: CodeLabel[] = []
  private chikokuTypeList: CodeLabel[] = []
  private sotaiTypeList: CodeLabel[] = []
  private kekkonOptionList: CodeLabel[] = []
  private kibikiOptionList: CodeLabel[] = []
  private kinmuKeitaiList: CodeLabel[] = []
  private shugyouKeitaiCodeList: CodeLabel[] = []
  private koutsuhiRemoveFlg = false
  private kyukeiIsCalcable = false
  private kyukei1Must = 0
  private kyukei1AutoSettingButtonDisplayFlg = false
  private kyukei1AutoSettingPopoverMsg = ''
  private kyukei1AutoSettingButtonType = 'warning'
  private kyukei2IsOverKyukeiMust = false
  private hushurouAutoSettingButtonDisplayFlg = false
  private hushurouAutoSettingButtonType = 'warning'
  private hushurouAutoSettingPopoverMsg = ''
  private hushurouAutoSettingCalcKekka = 0
  private isPreviousWorkday = false

  protected elUploadAction = 'dummy'

  get formName(): string {
    return 'kintaiInputForm'
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return kintaiInputStore
  }
  get keyInfo(): KeyInfo {
    return {
      year: this.inputDate.getFullYear(),
      month: this.inputDate.getMonth() + 1,
      day: this.inputDate.getDate()
    }
  }
  get isEmptyRecord(): boolean {
    return false
  }

  get form(): ApiGeneralSinglePayload {
    return this.storeModule.editData !== null ? this.storeModule.editData : {}
  }

  get kaishiDate(): TcwFormDate {
    return this.form.kaishi && typeof this.form.kaishi === 'string'
      ? this.tcw.dateOf(this.form.kaishi)
      : null
  }
  set kaishiDate(newDate: TcwFormDate) {
    const dateStr = this.du.convertDateToStr(newDate, API_DAYTIME_FORMAT)
    this.updateValue('kaishi', dateStr)
  }
  /**
   * 不就労計算の基準時間.
   */
  get hushurouKijunJikan(): number {
    // 所定労働時間は勤怠時間情報に付属している
    const shoteiRoudouJikan = this.kintaiJikan?.shoteiRoudouJikan
    const gyoumuJikan = this.project?.shoteiRoudouJikan

    if (typeof shoteiRoudouJikan !== 'number') {
      if (typeof gyoumuJikan === 'number') {
        return gyoumuJikan
      } else {
        return 0
      }
    }

    if (typeof gyoumuJikan !== 'number') {
      return shoteiRoudouJikan
    }

    // プロジェクトの業務時間が所定労働時間より小さい場合はプロジェクト業務時間を優先
    return shoteiRoudouJikan > gyoumuJikan ? gyoumuJikan : shoteiRoudouJikan
  }
  private updateKaishiJikan(newJikan: Jikan | null): void {
    if (!newJikan) {
      this.kaishiDate = null
      return
    }

    const day = this.form.day as TcwAPIDate
    const baseDate = this.tcw.dateOf(day)
    if (baseDate) {
      this.kaishiDate = newJikan.getDateValue(baseDate)
    }

    // 終了時間との前後関係をチェックし、必要に応じて日付を補正する
    const isTeppenGoe = this.shuryoJikan && newJikan.afterEquals(this.shuryoJikan) // 日をまたいで作業したか
    if (
      !isTeppenGoe &&
      baseDate &&
      this.shuryoDate &&
      !this.du.equalsDate(baseDate, this.shuryoDate)
    ) {
      // 日をまたいでいないのに終了時間が翌日付の場合は当日に修正する
      const newShuryoDate = new Date(this.shuryoDate)
      newShuryoDate.setDate(baseDate.getDate())
      this.shuryoDate = newShuryoDate
    } else if (
      isTeppenGoe &&
      baseDate &&
      this.shuryoDate &&
      this.du.equalsDate(baseDate, this.shuryoDate)
    ) {
      // 日をまたいだのに終了時間が翌日付になっていない場合は翌日付に変更する
      const newShuryoDate = new Date(this.shuryoDate)
      newShuryoDate.setDate(baseDate.getDate() + 1)
      this.shuryoDate = newShuryoDate
    }
  }
  get shuryoDate(): TcwFormDate {
    return this.form.shuryo && typeof this.form.shuryo === 'string'
      ? this.tcw.dateOf(this.form.shuryo)
      : null
  }
  set shuryoDate(newDate: TcwFormDate) {
    const dateStr = this.du.convertDateToStr(newDate, API_DAYTIME_FORMAT)
    this.updateValue('shuryo', dateStr)
  }
  private updateShuryoJikan(newJikan: Jikan | null) {
    if (!newJikan) {
      this.shuryoDate = null
      return
    }

    const day = this.form.day as TcwAPIDate
    const baseDate = this.tcw.dateOf(day)
    if (baseDate) {
      const newDate = newJikan.getDateValue(baseDate)

      // 開始と終了時間の前後が逆転している（同一含む）場合、終了翌日日付に変更する
      if (this.kaishiJikan && this.kaishiJikan.afterEquals(newJikan)) {
        const newDateValue = baseDate.getDate() + 1
        newDate.setDate(newDateValue)
      }

      this.shuryoDate = newDate
    }
  }

  get isKekkonKyuka(): boolean {
    return this.form?.kyujitsuCode === '10'
  }

  get isKibikiKyuka(): boolean {
    return this.form?.kyujitsuCode === '11'
  }

  get kyujitsuOptionList(): CodeLabel[] | null {
    if (this.isKekkonKyuka) {
      return this.kekkonOptionList
    } else if (this.isKibikiKyuka) {
      return this.kibikiOptionList
    } else {
      return null
    }
  }

  get chickokuOrSoutai(): boolean {
    return this.form.chikokuCode !== '0' || this.form.sotaiCode !== '0'
  }

  /**
   * 画面初期化 前処理
   */
  protected async beforeProc(): Promise<void> {
    // コードラベル情報をSTOREから取得する
    this.kyujitsuTypeList = await this.codeLabel.getCodeLabelList(KEY_CLASS_KYUJITSU_TYPE)
    this.chikokuTypeList = await this.codeLabel.getCodeLabelList(KEY_CLASS_CHIKOKU_TYPE)
    this.sotaiTypeList = await this.codeLabel.getCodeLabelList(KEY_CLASS_SOUTAI_TYPE)
    this.gyoushuList = await this.codeLabel.getCodeLabelList(KEY_CLASS_GYOUSHU_CODE)
    this.kekkonOptionList = await this.codeLabel.getCodeLabelList(KEY_CLASS_KEKKON_KYUKA_OPTION)
    this.kibikiOptionList = await this.codeLabel.getCodeLabelList(KEY_CLASS_KIBIKI_KYUKA_OPTION)
    this.kinmuKeitaiList = await this.codeLabel.getCodeLabelList(KEY_CLASS_KINMU_KEITAI)
    this.shugyouKeitaiCodeList = await this.codeLabel.getCodeLabelList(
      KEY_CLASS_KINMU_JIKAN_KEISAN_TYPE
    )

    // 交通費をクリア
    this.koutsuhiHasseiInfo = {}
  }
  /**
   * 画面初期化 後処理
   */
  protected async afterProc(): Promise<void> {
    // 定時をプロジェクト情報から設定する
    if (this.project) {
      const dateStr = this.du.convertDateToStr(this.inputDate, 'YYYY-MM-DD')
      const teijiKaishiStr = `${dateStr} ${this.project.teijiKaishiJikoku}:00`
      const teijiShuryoStr = `${dateStr} ${this.project.teijiShuryoJikoku}:00`
      this.$set(this.form, 'teijiKaishi', this.tcw.dateOf(teijiKaishiStr))
      this.$set(this.form, 'teijiShuryo', this.tcw.dateOf(teijiShuryoStr))
      this.$set(this.form, 'teijiKyukei1', this.project?.kintaiPatternJson?.kyukei1)
      this.$set(this.form, 'teijiKyukei2', this.project.kintaiPatternJson.kyukei2)
    }

    // 勤怠パターンの取得
    this.fetchKintaiPatternList()

    // 時間情報の設定
    this.kaishiJikan = this.kaishiDate ? Jikan.generateByDate(this.kaishiDate) : null
    this.shuryoJikan = this.shuryoDate ? Jikan.generateByDate(this.shuryoDate) : null

    // 交通費情報取得(非同期)
    this.getKoutsuhi()

    // 遅延証明ファイル取得(非同期)
    this.getChienShoumei()

    // 勤務時間計算
    this.requestKintaiJikanCalc()

    // 出勤の場合
    this.isPreviousWorkday = this.tcw.isNotHoliday(this.form.kyujitsuCode as string)
  }
  protected checkSameKey(keyInfo: KeyInfo, editData: ApiGeneralSinglePayload): boolean {
    const [year, month, day]: number[] = [
      Number(keyInfo['year']),
      Number(keyInfo['month']),
      Number(keyInfo['day'])
    ]
    const targetDate: Date = new Date(year, month - 1, day)
    const storeDate = typeof editData['day'] === 'string' ? new Date(editData['day']) : null
    return this.du.equalsDate(targetDate, storeDate)
  }

  /**
   * 保存前処理
   */
  protected async beforeSaveProc(): Promise<void> {
    // 休日の場合の勤怠情報設定
    if (this.isHoliday) {
      this.setKyujitsuKintaiData()
    }
  }
  protected setKyujitsuKintaiData(): void {
    this.storeModule.updateRecord(this.kyujitsuData)
  }
  /**
   * 保存後処理
   */
  protected async afterSaveProc(): Promise<void> {
    // 電車遅延の場合は遅延証明書をアップロードする
    if (this.isUploadChienShoumei) {
      // 遅延証明書のアップロード
      // console.log('遅延証明書をアップロードします')
      await this.uploadChienShoumei()
    }

    // 遅延証明書の削除
    if (this.isDeleteChienShoumei) {
      // console.log('遅延証明書を削除します')
      await this.deleteChienShoumei()
    }

    // 交通費を削除している場合
    if (this.koutsuhiRemoveFlg) {
      await this.deleteKoutsuhi()
    }

    this.clearForm()

    this.$tcw.message({
      type: 'success',
      message: '保存しました',
      offset: 100
    })

    // 保存完了
    this.successSave()
  }
  private get isHoliday(): boolean {
    const kyujitsuCode = this.form.kyujitsuCode
    if (typeof kyujitsuCode !== 'string') {
      return false
    }
    return this.tcw.isHoliday(kyujitsuCode)
  }

  get koutsuhiPatternOptions(): CodeLabel[] {
    return this.koutsuhiPatternList.map(pattern => {
      return {
        code: String(pattern.id),
        label: String(pattern.patternName)
      }
    })
  }
  private async changeKintaiJikan(): Promise<void> {
    // 勤務時間の再計算(サーバ処理)
    if (this.jikanInputCnt === 0) {
      this.startJikanCalcProc()
    }
    this.jikanInputCnt++
  }

  /**
   * 時間計算処理リクエスト
   */
  private startJikanCalcProc(): void {
    this.isCalculating = true
    // 連続で変更された場合を考慮して時間差でリクエストする
    setTimeout(() => {
      // 一定時間後、まだ入力が続いているか判定する
      if (this.jikanInputCnt <= 1) {
        this.requestKintaiJikanCalc()
      } else {
        this.startJikanCalcProc()
      }
      this.jikanInputCnt = 0
    }, 1300)
  }

  /**
   * 休憩時間、不就労時間など、賃金が発生しない時間を勤怠時間から自動計算する
   */
  private calcUnpaidTime(): void {
    // 休憩(日中)を自動設定する
    this.setKyukei1Automatically()
    // 不就労を自動設定する
    this.setHushurouAutomatically()
  }

  /**
   * 休憩(日中)を自動設定する
   */
  private setKyukei1Automatically() {
    // 最初にポップオーバー表示用フラグを全て初期化する
    this.setAllKyukei1AutoSettingFlgsToDefault()
    // 休憩を引く前の実働時間を計算
    const jitsudouWithKyukei =
      (this.kintaiJikan.jitsudou as number) +
      (this.form.kyukei1 as number) +
      (this.form.kyukei2 as number)
    this.kyukeiIsCalcable = this.isCalcableKyukeiMust(jitsudouWithKyukei)
    if (!this.kyukeiIsCalcable) {
      // 最低限必要な休憩時間が計算不能な場合、メッセージを表示
      this.kyukei1AutoSettingButtonType = 'danger'
      this.kyukei1AutoSettingButtonDisplayFlg = true
      this.kyukei1AutoSettingPopoverMsg =
        '勤怠時間を確認してください。\n' +
        '現在の勤怠時間では最低限必要な休憩時間を確定できません。\n' +
        `休憩時間が引かれる前の勤怠時間: ${this.du.outputHun(jitsudouWithKyukei, false)}\n` +
        `休憩しない場合の実働時間: ${this.du.outputHun(jitsudouWithKyukei, false)}\n` +
        `45分休憩した場合の実働時間: ${this.du.outputHun(jitsudouWithKyukei - 45, false)}\n` +
        `60分休憩した場合の実働時間: ${this.du.outputHun(jitsudouWithKyukei - 60, false)}\n` +
        `75分休憩した場合の実働時間: ${this.du.outputHun(jitsudouWithKyukei - 75, false)}`
      return
    }
    // 最低限必要な休憩時間(日中＋深夜)を取得
    const kyukeiMust = this.calcKyukeiMust(jitsudouWithKyukei)
    // 既に深夜の休憩時間が設定されていて、そちらが最低限必要な休憩時間を超過しているとき、警告メッセージを表示
    if (kyukeiMust < (this.form.kyukei2 as number)) {
      this.kyukei2IsOverKyukeiMust = true
      this.kyukei1AutoSettingButtonType = 'danger'
      this.kyukei1AutoSettingButtonDisplayFlg = true
      this.kyukei1AutoSettingPopoverMsg =
        '休憩(深夜)の時間を確認してください。\n' +
        '休憩(深夜)に最低限必要な休憩時間を超過する時間が設定されています。\n' +
        `最低限必要な休憩時間(日中+深夜): ${kyukeiMust}分\n` +
        `設定されている休憩(深夜): ${this.form.kyukei2 as number}分`
      return
    }
    // 最低限必要な休憩時間(日中)を取得。
    // 既に深夜の休憩時間が設定されていた場合、トータルで必要な休憩時間から深夜の休憩を引いた分を日中取る必要のある休憩時間とする
    const kyukei1Must = kyukeiMust - (this.form.kyukei2 as number)
    if (kyukei1Must === (this.form.kyukei1 as number)) {
      // 既に休憩(日中)が最低限必要な休憩(日中)と一致していたらメッセージを表示しない(既に表示されている場合は消す)
      this.setAllKyukei1AutoSettingFlgsToDefault()
      return
    }
    // 一致していないとき、設定を促すメッセージを表示する。
    this.kyukei1AutoSettingButtonType = 'warning'
    this.kyukei1AutoSettingButtonDisplayFlg = true
    this.kyukei1Must = kyukei1Must
    this.kyukei1AutoSettingPopoverMsg =
      '現在の勤怠時間で最低限必要な休憩時間(日中)を設定しますか？\n' +
      `設定される休憩(日中): ${kyukei1Must}分\n` +
      `休憩時間が引かれる前の勤怠時間: ${this.du.outputHun(jitsudouWithKyukei, false)}\n` +
      `最低限必要な休憩時間(日中+深夜): ${kyukeiMust}分\n` +
      `上記の時間休憩した場合の実働時間: ${this.du.outputHun(
        jitsudouWithKyukei - kyukei1Must,
        false
      )}`
  }

  /**
   * 休憩時間を引く前の実働時間から最低限必要な休憩時間を算出できるかどうか判定する
   */
  private isCalcableKyukeiMust(hun: number): boolean {
    // 実働が以下のとき、最低限必要な休憩時間を算出できない
    // 実働が9時間超9時間15分以下のとき、75分休憩すると実働が8時間になり75分休憩する根拠がなくなり、60分休憩すると実働が8時間15分になり75分の休憩が必要となる
    // 実働が8時間45分以上9時間未満のとき、45分休憩すると実働が8時間になり60分の休憩が必要になり、60分休憩すると実働が7時間45分になり60分休憩する根拠がなくなる
    // 実働が6時間以上6時間45分未満のとき、45分休憩すると実働が5時間15分になり45分休憩する根拠がなくなり、休憩しないと実働が6時間になり45分休憩する必要がある
    const time = hun / 60
    return !((9 < time && time <= 9.25) || (8.75 <= time && time < 9) || (6 <= time && time < 6.75))
  }

  /**
   * 休憩時間を引く前の実働時間から最低限必要な休憩時間を算出する
   * 休憩時間に関しては以下の①～④のルールがあり、これらに則り最低限必要な休憩時間を計算する。
   * ①実働が8時間超のとき、75分の休憩が必要 (ET就業規則)
   * ②実働が8時間のとき、60分の休憩が必要 (ET就業規則)
   * ③実働が6時間以上8時間未満のとき、45分の休憩が必要 (ET就業規則)
   * ④実働が6時間未満のとき、休憩は不要 (労働基準法)
   */
  private calcKyukeiMust(hun: number): number {
    const time = hun / 60
    if (9.25 < time) {
      // 9時間15分超なら75分
      return 75
    } else if (time === 9) {
      // 9時間なら60分
      return 60
    } else if (6.75 <= time && time < 8.75) {
      // 6時間45分以上8時間45分未満なら45分
      return 45
    } else {
      // 6時間未満なら0分
      return 0
    }
  }

  /**
   * 休憩(日中)自動設定ダイアログ表示に関係するフラグをすべて初期値に戻す
   */
  private setAllKyukei1AutoSettingFlgsToDefault(): void {
    this.kyukeiIsCalcable = false
    this.kyukei1Must = 0
    this.kyukei2IsOverKyukeiMust = false
    this.kyukei1AutoSettingButtonDisplayFlg = false
    this.kyukei1AutoSettingPopoverMsg = ''
    this.kyukei1AutoSettingButtonType = 'warning'
  }

  /*********************
   * 不就労自動設定関連
   *********************/

  /**
   * 不就労を自動設定する
   */
  private setHushurouAutomatically(): void {
    if (
      this.project == null ||
      this.kintaiJikan == null ||
      typeof this.kintaiJikan.jitsudou !== 'number' ||
      this.kaishiDate == null ||
      this.form.teijiKaishi == null ||
      this.shuryoDate == null ||
      this.form.teijiShuryo == null
    ) {
      return
    }

    // 不就労時間計算
    let hushurou = this.hushurouKijunJikan - this.kintaiJikan.jitsudou

    // 電車遅延、直行(遅刻区分が「なし」)の場合、開始時間が定時より遅くても不就労としない
    const kaishiDiff =
      (this.kaishiDate.getTime() - ((this.form.teijiKaishi as unknown) as Date).getTime()) /
      (1000 * 60)
    if (
      kaishiDiff > 0 &&
      (this.isDenshaChien(this.form?.chikokuCode as string) ||
        (this.form?.chikokuCode as string) === '0')
    ) {
      hushurou -= kaishiDiff
    }
    // 直帰(早退区分が「なし」)の場合、開始時間が定時より早くても不就労としない
    const shuryoDiff =
      (((this.form.teijiShuryo as unknown) as Date).getTime() - this.shuryoDate.getTime()) /
      (1000 * 60)
    if ((this.form?.sotaiCode as string) === '0' && shuryoDiff > 0) {
      hushurou -= shuryoDiff
    }

    // 上記電車遅延・直行・直帰の場合を考慮した結果、不就労がマイナスになることもあるので、その場合は不就労を0とする。
    hushurou = Math.max(hushurou, 0)

    if (hushurou === this.form.hushurou) {
      // 不就労の欄に設定されている値と計算結果が一致する場合、不就労時間自動設定ポップオーバーを表示しない
      this.hideHushurouJidouSetteiPopover()
    } else {
      // 不就労の欄に設定されている値と計算結果が一致しない場合、不就労時間自動設定ポップオーバーを表示する
      // ポップオーバーに表示するメッセージを作成
      const msg = this.createHushurouJidouSetteiPopoverMsg(hushurou)
      // 不就労時間自動設定ポップオーバー、ボタンを表示する
      this.showHushurouJidouSetteiPopover(hushurou, msg)
    }
  }

  /**
   * 不就労自動設定ポップオーバーに表示するメッセージを作成する
   */
  private createHushurouJidouSetteiPopoverMsg(hushurou: number): string {
    // 戻り値として返すメッセージ
    const msg: Array<string> = []
    msg.push('現在の勤怠情報をもとに不就労時間を設定しますか？')
    msg.push(`設定される不就労時間: ${hushurou}分`)
    // 各要素の間に改行コードを付与して返却
    return msg.join('\n')
  }

  /**
   * 不就労自動設定ポップオーバーを表示する
   */
  private showHushurouJidouSetteiPopover(hushurou: number, msg: string): void {
    this.hushurouAutoSettingButtonType = 'warning'
    this.hushurouAutoSettingButtonDisplayFlg = true
    this.hushurouAutoSettingPopoverMsg = msg
    this.hushurouAutoSettingCalcKekka = hushurou
  }

  /**
   * 不就労自動設定ポップオーバーを非表示にする
   */
  private hideHushurouJidouSetteiPopover(): void {
    this.hushurouAutoSettingCalcKekka = 0
    this.hushurouAutoSettingPopoverMsg = ''
    this.hushurouAutoSettingButtonDisplayFlg = false
    this.hushurouAutoSettingButtonType = 'warning'
  }

  /*********************
   * 遅延証明書
   *********************/
  protected isDenshaChien(chikokuCode: string | null): boolean {
    return chikokuCode === '2'
  }
  protected async getChienShoumei(): Promise<void> {
    // 電車遅延以外の場合は何もしない
    if (!this.isDenshaChien(String(this.form?.chikokuCode))) {
      return
    }

    this.chienShoumeiLoading = true
    try {
      // 遅延証明書を設定
      const kintaiId = this.form?.id
      this.fileList = await this.fetchChienShoumei(kintaiId)
      // console.debug('遅延証明書を取得', this.fileList)
    } catch (e) {
      // console.warn(e)
      this.$tcw.message({
        type: 'error',
        message: '遅延証明書の取得に失敗'
      })
    } finally {
      this.chienShoumeiLoading = false
    }
  }
  /**
   * 遅延証明書をサーバにアップロードする
   */
  private async uploadChienShoumei(): Promise<void> {
    if (!this.form.id) {
      return Promise.reject(new TCWDataLoadError('勤怠データが未取得です'))
    }

    this.isLoading = true

    try {
      // FormData を利用して File を POST する
      await this.uploadFile(String(this.form.id))
      this.$tcw.message({
        type: 'success',
        message: '遅延証明書をアップロードしました'
      })
    } catch (e) {
      this.$tcw.message({
        type: 'error',
        message: '遅延証明書のアップロードに失敗しました'
      })
    } finally {
      this.isLoading = false
    }
  }

  protected async deleteChienShoumei(): Promise<void> {
    if (!this.form.id) {
      return Promise.reject(new TCWDataLoadError('勤怠データが未取得です'))
    }

    this.isLoading = true
    try {
      // FormData を利用して File を POST する
      await this.deleteFile()
    } catch (e) {
      this.$tcw.message({
        type: 'error',
        message: '遅延証明書の削除に失敗しました'
      })
    } finally {
      this.isLoading = false
    }
  }
  /**
   * 遅延証明書をアップロードするかどうか判定
   */
  protected get isUploadChienShoumei(): boolean {
    // 電車遅延でなければアップしない
    if (!this.isDenshaChien(this.form?.chikokuCode as string)) {
      return false
    }

    // アップロード対象のファイルが存在しているか
    if (!this.hasUploadFile) {
      return false
    }

    // ファイルが準備できてなければアップしない
    const isReady = this.fileList.every(f => f.status === 'ready' || f.status === 'success')
    if (!isReady) {
      return false
    }

    return true
  }
  /**
   * 遅延証明書を削除するかどうか判定
   */
  protected get isDeleteChienShoumei(): boolean {
    // 削除対象のファイルが存在しているか
    if (!this.hasDeleteFile) {
      return false
    }
    return true
  }

  /*********************
   * 勤怠時間
   *********************/
  protected async requestKintaiJikanCalc(): Promise<void> {
    try {
      this.isCalculating = true
      const path = ApiPath.Paths.KintaiInput.calc
      const response = await this.getWebApi().call<ApiGeneralSinglePayload>(
        path,
        'POST',
        this.form as ApiGeneralSinglePayload
      )
      this.kintaiJikan = response
      // 休憩(日中)・不就労の自動設定用の計算を行う
      this.calcUnpaidTime()
    } catch (e) {
      console.error(e)
      if (e instanceof TCWApiError) {
        this.$tcw.message({
          type: 'error',
          title: '勤怠時間の計算に失敗しました。',
          message: e.message
        })
      } else {
        throw e
      }
    } finally {
      this.isCalculating = false
    }
  }

  /*********************
   * 交通費関連
   *********************/
  private get koutsuhiKingaku(): string {
    if (!this.koutsuhiHasseiInfo?.id) {
      return ''
    }
    return '￥' + this.koutsuhiHasseiInfo?.goukeiKingaku?.toLocaleString()
  }
  protected async getKoutsuhi(): Promise<void> {
    this.isLoading = true
    const path = ApiPath.buildPath(ApiPath.Paths.KoutsuhiBrowse.get, {
      year: this.inputDate.getFullYear(),
      month: this.inputDate.getMonth() + 1,
      day: this.inputDate.getDate()
    })
    try {
      const response = await this.getWebApi().call<ApiGeneralSinglePayload>(path, 'GET')
      this.koutsuhiHasseiInfo = response
    } catch (e) {
      if (e instanceof TCWApiError && e.getErrorCode() === ERR_CODE_WEB_API_NOT_FOUND) {
        console.log('交通費なし')
      } else {
        throw e
      }
    } finally {
      this.isLoading = false
    }
  }
  private openKoutsuhi(): void {
    this.$router.push('/koutsuhi/input')
  }
  private removeKoutsuhi(): void {
    this.koutsuhiHasseiInfo = {}
    this.updateValue('koutsuhiId', null)
    this.koutsuhiRemoveFlg = true
  }
  private async deleteKoutsuhi(): Promise<void> {
    // リクエスト情報の生成
    const path = ApiPath.buildPath(ApiPath.Paths.KoutsuhiInput.delete, this.keyInfo)

    try {
      // FormData を利用して File を POST する
      await this.getWebApi().call(path, 'DELETE')
    } catch (e) {
      this.$tcw.message({
        type: 'error',
        message: '交通費の削除に失敗しました'
      })
    } finally {
      this.koutsuhiRemoveFlg = false
    }
  }

  private changeKyujitsuCode(kyujitsuCode: string): void {
    // 勤怠時間計算
    this.changeKintaiJikan()

    // 休日に変更した場合
    if (this.tcw.isHoliday(kyujitsuCode)) {
      // 休日区分を休日系のものに変更するときは備考欄をクリアする
      this.form.biko = ''
      // 変更前が出勤のときは交通費情報を削除
      if (this.isPreviousWorkday) {
        this.removeKoutsuhi()
      }
      this.isPreviousWorkday = this.tcw.isNotHoliday(kyujitsuCode)
      return
    }
    this.isPreviousWorkday = this.tcw.isNotHoliday(kyujitsuCode)

    // 空データに対してデフォルト値を設定 TODO 本当はデフォルト勤怠パターンの値を設定
    if (!this.form.chikokuCode) {
      this.form.chikokuCode = '0'
    }
    if (!this.form.sotaiCode) {
      this.form.sotaiCode = '0'
    }
    if (!this.form.shugyouKeitaiCode) {
      this.form.shugyouKeitaiCode = this.$tcw.session.user?.shugyouKeitaiCode
        ? this.$tcw.session.user?.shugyouKeitaiCode
        : '1'
    }
    if (!this.form.kaishi) {
      if (
        typeof this.form.day === 'string' &&
        typeof this.project?.teijiKaishiJikoku === 'string'
      ) {
        this.form.kaishi = this.getDefaultTimeByJikoku(
          this.form.day,
          this.project?.teijiKaishiJikoku
        )
        this.kaishiJikan = this.kaishiDate ? Jikan.generateByDate(this.kaishiDate) : null
      }
    }

    if (!this.form.shuryo) {
      if (
        typeof this.form.day === 'string' &&
        typeof this.project?.teijiShuryoJikoku === 'string'
      ) {
        this.form.shuryo = this.getDefaultTimeByJikoku(
          this.form.day,
          this.project?.teijiShuryoJikoku
        )
        this.shuryoJikan = this.shuryoDate ? Jikan.generateByDate(this.shuryoDate) : null
      }
    }
  }
  private getDefaultTimeByJikoku(day: string, jikoku: string): string {
    const defaultDateTime = this.tcw.dateOf(day + ' ' + jikoku)
    return this.du.convertDateToStr(defaultDateTime, API_DAYTIME_FORMAT)
  }
  get kintaiPatternOptions(): CodeLabel[] {
    return this.kintaiPatternList.map(pattern => {
      if (!pattern || typeof pattern !== 'object') {
        return { code: '', label: '' }
      }
      return {
        code: Number(pattern.id),
        label: `${pattern.patternName}`
      }
    })
  }
  get kintaiPattern(): ApiGeneralSinglePayload | null {
    if (!this.form?.kintaiPatternId) {
      return null
    }
    const pattern = this.kintaiPatternList.find(
      (p: ApiGeneralSinglePayload) => String(p.id) === String(this.form?.kintaiPatternId)
    )
    return pattern ? pattern : null
  }
  protected async fetchKintaiPatternList(): Promise<void> {
    try {
      const response = await this.getWebApi().call<ApiGeneralObjectArrayPayload>(
        ApiPath.Paths.KintaiPatternList.get,
        'GET'
      )
      this.kintaiPatternList = response
    } catch (e) {
      this.$tcw.message({
        message: '勤怠パターンが取得できませんでした',
        type: 'success'
      })
      console.log('error ocuread')
    }
  }
  protected selectKintaiPattern(selectedId: TcwAPIID): void {
    if (selectedId === null) {
      return
    }
    // 引数で渡されてきたselectedIdとkintaipatternListを比べ、合致したオブジェクトを取得
    const strId = String(selectedId)
    let targetPattern = this.kintaiPatternList.find(pattern => String(pattern.id) === strId)
    if (!targetPattern) {
      return
    }
    //勤怠パターンにセットされた情報をUIに反映
    if (typeof this.form.day === 'string' && typeof targetPattern.kaishi === 'string') {
      this.form.kaishi = this.getDefaultTimeByJikoku(this.form.day, targetPattern.kaishi)
      this.kaishiJikan = this.kaishiDate ? Jikan.generateByDate(this.kaishiDate) : null
    }
    if (typeof this.form.day === 'string' && typeof targetPattern.shuryo === 'string') {
      this.form.shuryo = this.getDefaultTimeByJikoku(this.form.day, targetPattern.shuryo)
      this.shuryoJikan = this.shuryoDate ? Jikan.generateByDate(this.shuryoDate) : null
    }
    this.form.kyukei1 = targetPattern.kyukei1
    this.form.kyukei2 = targetPattern.kyukei2
    this.form.hushurou = targetPattern.hushurou
    this.form.shugyouKeitaiCode = targetPattern.shugyouKeitaiCode
    this.form.kinmuKeitai = targetPattern.kinmuKeitai
    this.form.biko = targetPattern.biko
    console.log(targetPattern.biko)
    // 勤務時間計算
    this.requestKintaiJikanCalc()
    
  }
}
